module.exports = __webpack_public_path__ + "img/pencil-icon.2adb36c7.svg";